import { useStore } from '@/store'
import { Directive, toRaw } from 'vue'

export const permission:Directive = {
    mounted(el, binding) {
        // 判断是否有权限
        const hasPermission = (val:string):boolean => {
            const actions = useStore().state.user.currRoute.meta.actions || []
            const item = actions.find(item => item.name === val)
            return item ? false : true
        }

        if (hasPermission(binding.value)) {
            el.parentNode.removeChild(el)
        }
    }
}